import React from 'react';

const In = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M4.905 2.02C4.938 2.017 4.966 2 5 2h14.334c2.205 0 4 1.795 4 4v1.333a1.334 1.334 0 01-2.667 0V6c0-.735-.599-1.333-1.333-1.333h-6.213l.407.136a2.68 2.68 0 011.805 2.53v20h4c.735 0 1.334-.598 1.334-1.333v-2.667a1.334 1.334 0 012.667 0V26c0 2.205-1.795 4-4 4h-4v1.333A2.67 2.67 0 0112.667 34c-.286 0-.556-.041-.85-.132l-8.01-2.67A2.68 2.68 0 012 28.666v-24C2 3.112 3.34 1.893 4.905 2.02z"
            fill={fill}
        />
        <path
            className="u_fill"
            d="M19.723 14.39l5.334-5.334a1.333 1.333 0 012.276.943v4h5.334a1.334 1.334 0 010 2.666h-5.334v4a1.333 1.333 0 01-2.276.943l-5.334-5.333a1.332 1.332 0 010-1.886z"
            fill={fill}
        />
    </svg>
);

export default In;